type NavigateFn = (to: string, options?: { replace?: boolean }) => void

let navigateFn: NavigateFn | null = null

// App.tsx registers the data router's navigate so non-React code
// (e.g. ApiService error handling) can trigger in-app navigation
export function registerNavigate(fn: NavigateFn) {
    navigateFn = fn
}

export function navigate(to: string, options?: { replace?: boolean }) {
    if (navigateFn) {
        navigateFn(to, options)
    } else {
        window.location.assign(to)
    }
}
